import { render, staticRenderFns } from "./Contractors.vue?vue&type=template&id=4dcbd4a7&scoped=true&"
import script from "./Contractors.vue?vue&type=script&lang=ts&"
export * from "./Contractors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcbd4a7",
  null
  
)

export default component.exports